import type { FC, ReactNode } from 'react';
import { isValidElement } from 'react';
import { Typography } from 'antd';

import { useAdminLayoutPageHeading } from './AdminLayoutPageHeadingContext.tsx';

import './ResponsivePageHeading.css';

type ResponsivePageHeadingProps = {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
  singleLine?: boolean;
};

const renderDescription = (description: ReactNode) => {
  return (
    <div className="responsive-page-heading__description">
      {isValidElement(description) ? (
        description
      ) : (
        <Typography.Paragraph type="secondary">
          {description}
        </Typography.Paragraph>
      )}
    </div>
  );
};

const ResponsivePageHeading: FC<ResponsivePageHeadingProps> = ({
  title,
  description,
  actions,
  className,
  singleLine = false,
}) => {
  const context = useAdminLayoutPageHeading();
  const resolvedTitle = title ?? context?.currentPageTitle ?? null;
  const isHeaderTitleVisible = context?.isHeaderTitleVisible ?? false;
  const showTitle = Boolean(resolvedTitle) && !isHeaderTitleVisible;
  const hasDescription = description !== undefined && description !== null && description !== false;
  const hasActions = actions !== undefined && actions !== null && actions !== false;

  if (!showTitle && !hasDescription && !hasActions) {
    return null;
  }

  const classes = [
    'responsive-page-heading',
    !showTitle ? 'responsive-page-heading--title-hidden' : '',
    singleLine ? 'responsive-page-heading--single-line' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <header className={classes}>
      {(showTitle || hasDescription) ? (
        <div className="responsive-page-heading__main">
          {showTitle ? (
            <Typography.Title level={2} className="responsive-page-heading__title">
              {resolvedTitle}
            </Typography.Title>
          ) : null}
          {hasDescription ? renderDescription(description) : null}
        </div>
      ) : null}
      {hasActions ? <div className="responsive-page-heading__actions">{actions}</div> : null}
    </header>
  );
};

export default ResponsivePageHeading;
